import { BadgeCheck } from "lucide-react";
import { cn } from "@lib/utils";
import { Button } from "@primitives/button";
import { Theme, useThemeState } from "@/zustand/ThemeState";
import { useTranslation } from "react-i18next";

/**
 * Theme configuration data structure
 */
type ThemeConfig = {
  id: Theme;
  displayName: string;
  gradient: string;
};

/**
 * Available themes configuration
 */
const themes: ThemeConfig[] = [
  {
    id: "midnight-green",
    displayName: "Midnight Emerald",
    gradient:
      "bg-gradient-to-tr from-green-900 to-emerald-500 dark:from-teal-950 dark:to-emerald-400",
  },
  {
    id: "orion-blue",
    displayName: "Legacy Blue",
    gradient:
      "bg-gradient-to-tr from-blue-600 to-blue-400 dark:from-blue-700 dark:to-cyan-500",
  },
  // {
  //   id: "lemon-tree",
  //   displayName: "Lemon Tree",
  //   gradient:
  //     "bg-gradient-to-tr from-yellow-300 to-yellow-950 dark:from-yellow-950 dark:to-yellow-300",
  // },
  // {
  //   id: "purple-rain",
  //   displayName: "Purple Rain",
  //   gradient:
  //     "bg-gradient-to-tr from-violet-300 to-violet-700 dark:from-violet-300 dark:to-violet-700",
  // },
  // {
  //   id: "peppermint",
  //   displayName: "Peppermint",
  //   gradient:
  //     "bg-gradient-to-tr from-lime-300 to-lime-700 dark:from-lime-300 dark:to-lime-700",
  // },
];

/**
 * Theme selection component that displays available themes as buttons
 * and allows the user to select one
 */
export default function ThemeSection() {
  const { t } = useTranslation();
  const { theme, setTheme } = useThemeState();

  return (
    <div className="my-2 py-2">
      <h5 className="mb-2 text-xs font-light text-foreground/50">
        {t("appearance.theme")}
      </h5>

      <div className="flex flex-col gap-3">
        {themes.map((themeOption) => (
          <Button
            key={themeOption.id}
            onClick={() => setTheme(themeOption.id)}
            variant="outline"
            className={cn(
              "flex h-14 items-center justify-start gap-2 rounded-md border-border p-2 align-middle text-foreground",
              theme === themeOption.id && "border-primary",
            )}
          >
            <div
              className={`size-10 rounded-full ${themeOption.gradient}`}
            ></div>
            <span className="text-sm font-normal">
              {themeOption.displayName}
            </span>
            {theme === themeOption.id && (
              <BadgeCheck className="ml-auto size-5 text-green-500" />
            )}
          </Button>
        ))}
      </div>
    </div>
  );
}
